import gql from 'graphql-tag';

export const ReopenInlineCommentMutation = gql`
	mutation ReopenInlineCommentMutation($commentId: ID!) {
		resolveInlineComment(commentId: $commentId, resolved: false, dangling: false) {
			status
		}
	}
`;
